import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EncoderService {

  constructor() { }

  encode(item: string): string {
    return btoa(unescape(encodeURIComponent(item)));
  }

  decode(item: string): string {
    const raw = atob(item);
    try {
      return decodeURIComponent(escape(raw));
    } catch {
      // Valor guardado antes de aplicar el escapado UTF-8-safe: los bytes
      // Latin-1 sueltos (tildes/ñ) no forman una secuencia UTF-8 válida y
      // decodeURIComponent lanza URIError. En ese esquema antiguo btoa()
      // codificaba el string tal cual, así que atob() ya es el valor original.
      return raw;
    }
  }
}
